import { useEffect } from "react";
import TagManager from "react-gtm-module";

const GTM_ID = "GTM-NFM885JS";

export const useGoogleAnalytics = (): void => {
	// Initialize Google Tag Manager
	useEffect(() => {
		TagManager.initialize({
			gtmId: GTM_ID,
		});
	}, []);
};
